import { Image, Link, Page, Text, View } from '@react-pdf/renderer';
import brandLogo from './images/brand-logo.png';
import { coverImage } from './helper';
import { translations } from './interfaces';
import { FC } from 'react';
import { styles } from './styles';

interface ILastPage {
  translations: translations;
}
export const LastPage: FC<ILastPage> = ({ translations }) => (
  <Page orientation="landscape" style={[styles.page]}>
    <View style={{ height: '100%', width: '100%', position: 'relative' }}>
      <Image
        source={coverImage(translations)}
        style={[styles.backgroundImage, { opacity: 0.5, top: '5px' }]}
      />
      <View style={styles.banner}>
        <View style={styles.bannerContent}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <Image
              source={brandLogo}
              style={{ width: '120px', marginLeft: '5px' }}
            />
            <View
              style={{
                display: 'flex',
                marginLeft: 20,
                flexDirection: 'column',
                color: '#fff',
                fontSize: '12px'
              }}
            >
              <Text>[ui!] Urban Software Institute</Text>
              <Text>Zwickauer Str. 223a </Text>
              <Text>D-09116 Chemnitz </Text>
              <Link src="mailto:info@ui.city" style={styles.noLinkStyle}>
                <Text>E-Mail: info@ui.city</Text>
              </Link>
              <Link src="http://www.ui.city" style={styles.noLinkStyle}>
                <Text>Web: www.ui.city</Text>
              </Link>
            </View>
          </View>
          <View
            style={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            <Text
              style={{
                color: '#fff',
                fontSize: '13px',
                fontWeight: 'demibold'
              }}
            >{`${translations.version} ${translations.language}`}</Text>
          </View>
        </View>
      </View>
    </View>
  </Page>
);
